export const PAYMENT_TYPES = [
    {
        id: 'manual',
        value: 'manual',
        title: 'Płatność samodzielna',
        label: 'płatność samodzielna',
        iconTooltip: 'Na początku każdego okresu rozliczeniowego otrzymasz dokument do opłacenia.<br/>Pamiętaj aby opłacić go w terminie'
    },
    {
        id: 'automatic',
        value: 'automatic',
        title: 'Automatyczne obciążenie karty',
        label: 'automatyczne obciążenie karty',
        iconTooltip: 'Na początku każdego okresu rozliczeniowego pobierzemy płatność z zapisanej karty'
    }
]

export const PAYMENT_STATUSES = {
    INITIAL: 'initial',
    PAID: 'paid',
    TO_POST: 'to_post',
    POSTED: 'posted',
    EXPIRED: 'expired',
    DEBT: 'debt',
    UNACCOUNTABLE: 'unaccountable',
    ZERO: 'zero',
    CLOSED: 'closed',
    ERROR: 'error'
}

export const PAID_STATUSES = [
    PAYMENT_STATUSES.PAID,
    PAYMENT_STATUSES.TO_POST,
    PAYMENT_STATUSES.POSTED,
    PAYMENT_STATUSES.UNACCOUNTABLE,
    PAYMENT_STATUSES.ZERO,
    PAYMENT_STATUSES.ERROR
]

export const UNPAID_STATUSES = [
    PAYMENT_STATUSES.INITIAL
]

export const EXPIRED_STATUSES = [
    PAYMENT_STATUSES.EXPIRED,
    PAYMENT_STATUSES.DEBT
]

export const DOCUMENT_TYPES = {
    MONTHLY: 'Document::Drs::Monthly',
    YEARLY: 'Document::Drs::Yearly'
}